import INVENTORY_API_BASE_URL from "../../config/api";














  





import React, { useState } from 'react';
import { useQuery } from '@apollo/client';
import axios from 'axios';
import { GET_ALL_RETURN_INBOUNDS } from '../queries'; 
 import "./returnscanpdf.css";

const ITEMS_PER_PAGE = 10;

const ReturnInboundList = () => {
  const { loading, error, data } = useQuery(GET_ALL_RETURN_INBOUNDS);
  const [expanded, setExpanded] = useState({});
  const [currentPage, setCurrentPage] = useState(1);
  const [grnDetails, setGrnDetails] = useState({});

  if (loading) return <p>Loading...</p>;
  if (error) return <p>Error fetching data: {error.message}</p>;

  const groupedData = data.getAllReturnInbounds.reduce((acc, item) => {
    if (!acc[item.grnNo]) acc[item.grnNo] = [];
    acc[item.grnNo].push(item);
    return acc;
  }, {});

  const grnGroups = Object.entries(groupedData).sort((a, b) => b[0] - a[0]);
  const totalPages = Math.ceil(grnGroups.length / ITEMS_PER_PAGE);
  const paginatedGroups = grnGroups.slice(
    (currentPage - 1) * ITEMS_PER_PAGE,
    currentPage * ITEMS_PER_PAGE
  );

  const combinedCountsByGrn = {};
  paginatedGroups.forEach(([grnNo, items]) => {
    combinedCountsByGrn[grnNo] = items.reduce((acc, item) => {
      if (!acc[item.sku]) {
        acc[item.sku] = {
          count: item.count,
          Title: item.Title, 
        };
      } else {
        acc[item.sku].count += item.count;
      }
      return acc;
    }, {});
  });

  const toggleGRN = async (grnNo) => {
    const isNowExpanded = !expanded[grnNo];
    setExpanded((prev) => ({ ...prev, [grnNo]: isNowExpanded }));

    if (isNowExpanded && !grnDetails[grnNo]) {
      try {
        const response = await axios.get(`${INVENTORY_API_BASE_URL}/return-grn/${grnNo}`);
        setGrnDetails((prev) => ({ ...prev, [grnNo]: response.data }));
      } catch (err) {
        console.error(`Error fetching GRN ${grnNo} data:`, err);
      }
    }
  };

  const goToPage = (page) => setCurrentPage(page);

  return (
    <div className="return-inbound-container">
      <h2 className="heading">Return Inbound Records</h2>

      <div className="pagination">
        {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
          <button
            key={page}
            onClick={() => goToPage(page)}
            style={{
              margin: '0 4px',
              padding: '6px 12px',
              backgroundColor: page === currentPage ? '#007bff' : '#eee',
              color: page === currentPage ? '#fff' : '#000',
              border: '1px solid #ccc',
              borderRadius: '4px',
            }}
          >
            {page}
          </button>
        ))}
      </div>

      {grnGroups.length === 0 ? (
        <p className="no-records">No records found.</p>
      ) : (
        <>
          {paginatedGroups.map(([grnNo, items]) => {
            const grnDetail = grnDetails[grnNo];
            const countMap = combinedCountsByGrn[grnNo] || {};

            return (
              <div key={grnNo} className="grn-group" style={{ marginTop: '20px' }}>
                <button onClick={() => toggleGRN(grnNo)}>
                  {expanded[grnNo] ? 'Hide' : 'Show'} Details for GRN: {grnNo}
                </button>

                {expanded[grnNo] && (
                  <>
                    {grnDetail && (
                      <div style={{ marginTop: '10px', fontWeight: 'bold' }}>
                        Distributor: {grnDetail.Distributor}
                      </div>
                    )}

                    <table className="data-table" style={{ marginTop: '10px', width: '100%', borderCollapse: 'collapse' }}>
                      <thead>
                        <tr>
                          <th style={{ border: '1px solid #ccc', padding: '8px' }}>S. No.</th>
                          <th style={{ border: '1px solid #ccc', padding: '8px' }}>SKU</th>
                          <th style={{ border: '1px solid #ccc', padding: '8px' }}>Title</th>
                          <th style={{ border: '1px solid #ccc', padding: '8px' }}>Count</th>
                          <th style={{ border: '1px solid #ccc', padding: '8px' }}>Returned</th>
                        </tr>
                      </thead>
                      <tbody>
                        {grnDetail?.Entries?.map((entry, idx) => {
                          const sku = entry.SKU;
                          const matched = countMap[sku];
                          const count = matched ? matched.count : 0;

                          return (
                            <tr key={idx}>
                              <td style={{ border: '1px solid #ccc', padding: '8px' }}>{idx + 1}</td>
                              <td style={{ border: '1px solid #ccc', padding: '8px' }}>{sku}</td>
                              <td style={{ border: '1px solid #ccc', padding: '8px' }}>{entry.Title}</td>
                              <td style={{ border: '1px solid #ccc', padding: '8px' }}>{count}</td>
                              <td style={{ border: '1px solid #ccc', padding: '8px' }}>{entry.Return_Quantity}</td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </>
                )}
              </div>
            );
          })}
        </>
      )}
    </div>
  );
};

export default ReturnInboundList;



